import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { RefreshCw } from 'lucide-react';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    // Listen for update available event
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              setShowUpdate(true);
              setRegistration(reg);
            }
          });
        });
      });
    }
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload(true);
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed top-16 left-1/2 transform -translate-x-1/2 z-[100] animate-in slide-in-from-top">
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-full shadow-2xl flex items-center gap-3">
        <RefreshCw className="h-5 w-5 animate-spin" />
        <span className="font-semibold">New version available!</span>
        <Button
          onClick={handleUpdate}
          size="sm"
          className="bg-white text-blue-600 hover:bg-gray-100 h-8 px-4 rounded-full font-bold"
        >
          Update Now
        </Button>
      </div>
    </div>
  );
};

export default UpdateNotification;
